import { Swiper, Navigation, Pagination } from "swiper/dist/js/swiper.esm.js";

Swiper.use([Navigation, Pagination]);

export default () => {
    var swiper = new Swiper('.gallery-modal-slider', {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
    });

    // componente de banner padrão
    let bannerDefault = new Swiper(".banner__default", {
        watchOverflow: true,
        navigation: {
            nextEl: '.banner-button-next',
            prevEl: '.banner-button-prev',
        },
        pagination: {
            el: ".banner-pagination",
            type: "bullets",
            clickable: true,
        },
    });

    let banner = new Swiper(".banner", {
        watchOverflow: true,
        pagination: {
            el: ".banner-pagination",
            type: "bullets",
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });

    let programation = new Swiper(".programation__days", {
        watchOverflow: true,
        navigation: {
            nextEl: ".programation-button-next",
            prevEl: ".programation-button-prev",
        },
        width: 70,
        centeredSlides: true,
        spaceBetween: 20,
    });

    let programationRadio = new Swiper(".programation__radio", {
        watchOverflow: true,
        navigation: {
            nextEl: ".radio-button-next",
            prevEl: ".radio-button-prev",
        },
        width: 70,
        centeredSlides: true,
        spaceBetween: 20,
    });

    let programs = new Swiper(".filter__container", {
        watchOverflow: true,
        navigation: {
            nextEl: ".filter-button-next",
            prevEl: ".filter-button-prev",

        },
        width: 100,
        spaceBetween: 20,
    }); 

    let bannerImmobile = new Swiper(".banner-mobile", {
        watchOverflow: true,
        pagination: {
            el: ".banner-mobile-pagination",
            type: "bullets",
            clickable: true,
        }, 
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        }, 
        mousewheel: true,
        keyboard: true, 
    });

    let swiperShowHome = new Swiper(".shows__items", {
        slidesPerView: 5,
        spaceBetween: 10, 
        navigation: {
            nextEl: ".show-slide-next",
            prevEl: ".show-slide-prev ",
        }, 
        breakpoints: {
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
          1024: {
            slidesPerView: 5,
            spaceBetween: 30,
          },
        },
      });
};
